import React from 'react';
import whiteAlLogo from "../images/whiteAlLogo.png";
import { Link } from "@material-ui/core";


const Logo = (props) => {
    return (
      <div className={props.className}>
        <Link color="inherit" href="https://analytics-lab.org/">
          <img
            src={whiteAlLogo}
            width={props.width}
            height={props.height}
            alt="Analytics Lab Logo"
          ></img>
        </Link>
      </div>
    );
}

export default Logo
